import { saveState, getSavedState } from '@utils/browser-help'

import request from '@utils/request'
import router, { resetRouter, generateUserRoutes } from '@router'

export const state = {
  currentUser: {},
  currentUserRoutes: [],
  currentUserComponents: [],
  currentUserPermission: {},
  currentUserTours: {},
  currentUserAccount: {},
  currentSubscription: null,
  currentSubscriptionAuthority: false,
}
//
export const mutations = {
  SET_STATE(state, newValue) {
    state = Object.assign(state, newValue)
  },
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    // await saveState('auth.currentUser', newValue);
    setDefaultAuthHeaders(state)
  },
  SET_CURRENT_USER_ACCESS(state, { assets, components, ...permission }) {
    state.currentUserRoutes = assets
    state.currentUserRoutes.push('employee-staff') // 新增頁面先加route
    state.currentUserComponents = components
    state.currentUserPermission = permission
    // await saveState('auth.currentUserRoutes', assets);
    // await saveState('auth.currentUserPermission', permission)
  },
  SET_CURRENT_USER_TOUR(state, tourPages) {
    state.currentUserTours = tourPages
    // await saveState('auth.currentUserTours', tourPages)
  },
  SET_CURRENT_USER_ACCOUNT(state, account) {
    state.currentUserAccount = account
    // await saveState('auth.currentUserAccount', account)
  },
  SET_CURRENT_SUBSCRIPTION(state, newValue) {
    state.currentSubscription = newValue
    // await saveState('auth.currentSubscription', newValue)
  },
  SET_CURRENT_SUBSCRIPTION_AUTHORITY(state, newValue) {
    state.currentSubscriptionAuthority = newValue
    // await saveState('auth.currentSubscriptionAuthority', newValue)
  },
  CLEAR_MERCHANT_CACHED(state) {
    // await saveState('merchant.cached', {})
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser && state.currentUserRoutes.length > 0
  },
  /**
   * @description 是否有購買儲值金開通模組
   */
  hasDeposit(state) {
    return state.currentUserComponents.includes('deposit')
  },
  /**
   * @description 是否有會員等級模組
   */
  hasMemberLevel(state) {
    return state.currentUserComponents.includes('memberlevel')
  },
  /**
   * @description 是否有商品模組
   */
  iaHasGoods(state) {
    return state.currentUserComponents.includes('goods')
  },
  merchantUrl() {
    let url = ''

    if (process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
      url = 'https://admin.ipetbooking.com'
    } else {
      if (!location.origin) {
        location.origin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
      }
      url = location.origin
    }

    return url.replace('admin.', '')
  },
  /**
   * @description 操作者是否有購買daycare
   */
  hasDayCare() {
    return state.currentUserComponents.includes('daycare')
  },
  hasGoods(state) {
    return state.currentUserRoutes.includes('goods')
  },
  /**
   * @description 是否有住宿模組
   */
  hasHotel(state) {
    return state.currentUserComponents.includes('hotel')
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  async init({ state, commit, dispatch }) {
    const initState = async () => {
      const stateData = {
        currentUser: await getSavedState('auth.currentUser'),
        currentUserRoutes: (await getSavedState('auth.currentUserRoutes')) || [],
        currentUserComponents: (await getSavedState('auth.currentUserComponents')) || [],
        currentUserPermission: (await getSavedState('auth.currentUserPermission')) || {},
        currentUserTours: (await getSavedState('auth.currentUserTours')) || {},
        currentUserAccount: (await getSavedState('auth.currentUserAccount')) || {},
        currentSubscription: (await getSavedState('auth.currentSubscription')) || null,
        currentSubscriptionAuthority: (await getSavedState('auth.currentSubscriptionAuthority')) || false,
      }

      commit('SET_STATE', stateData)

      return Promise.resolve()
    }

    await initState()

    setDefaultAuthHeaders(state)

    return Promise.resolve(state)
  },
  fetchTour({ commit }, readPage) {
    return request
      .get('/admin/merchant/user/tour', {
        params: {
          read: readPage,
        },
      })
      .then(async (response) => {
        const tourPages = response.items

        commit('SET_CURRENT_USER_TOUR', tourPages)
        await saveState('auth.currentUserTours', tourPages)

        return tourPages
      })
  },
  fetchAccess({ commit }) {
    return request.get('/admin/merchant/user/access').then(async (response) => {
      const { assets, components, ...permission } = response.items
      commit('SET_CURRENT_USER_ACCESS', response.items)
      await saveState('auth.currentUserRoutes', [...assets])
      await saveState('auth.currentUserComponents', [...components])
      await saveState('auth.currentUserPermission', permission)
      return generateUserRoutes(state)
    })
  },
  checkResetToken({ commit }, token) {
    return request
      .get(`/password/reset/${token}`)
      .then((response) => {
        return response.code === 200
      })
      .catch((error) => {
        // if (
        //   error.status === 'MERCHANT_FRONT_PLEASE_RENEW_SUBSCRIPTION' ||
        //   error.status === 'MERCHANT_FRONT_PLEASE_BIND_CARD_FIRST'
        // ) {
        //   commit('SET_CURRENT_USER', error.data.items)
        //   commit('SET_CURRENT_SUBSCRIPTION', error.data.items)
        // }
        return Promise.reject(error)
      })
  },
  reset({ commit }, resetData) {
    // token, password, passwordConfirm
    return request.post('/password/reset', resetData)
  },
  forgot({ commit }, email) {
    return request.post('/password/email', {
      email,
    })
  },
  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { email, password, identity, code } = {}) {
    // if (getters.loggedIn) return dispatch('validate')

    return request
      .post(
        '/admin/merchant/user/login',
        {
          email,
          password,
          identity,
          code,
        },
        {
          errorHandle: false,
          hideErrorMessage: true,
        }
      )
      .then(async (response) => {
        const user = response.items
        commit('SET_CURRENT_USER', user)
        await saveState('auth.currentUser', user)

        commit('SET_CURRENT_USER_ACCOUNT', {
          email,
          password,
        })
        await saveState('auth.currentUserAccount', {
          email,
          password,
        })

        return user
      })
      .catch(async (error) => {
        if (error.status === 'MERCHANT_FRONT_PLEASE_RENEW_SUBSCRIPTION' || error.status === 'MERCHANT_FRONT_PLEASE_BIND_CARD_FIRST') {
          commit('SET_CURRENT_USER', error.data.items)
          await saveState('auth.currentUser', error.data.items)

          commit('SET_CURRENT_SUBSCRIPTION', error.data.items)
          await saveState('auth.currentSubscription', error.data.items)
        }
        return Promise.reject(error)
      })
  },
  /**
   * 更新方案資訊
   */
  async clearSubscription({ commit, state }) {
    commit('SET_CURRENT_SUBSCRIPTION', null)
    await saveState('auth.currentSubscription', null)

    return Promise.resolve()
  },
  // 判斷訂閱方案的藍星金流 callback 頁面
  async updateAccessSubscription({ commit }, status) {
    commit('SET_CURRENT_SUBSCRIPTION_AUTHORITY', status)
    await saveState('auth.currentSubscriptionAuthority', status)

    return Promise.resolve()
  },

  // Logs out the current user.
  logOut({ commit }) {
    return request.get('/admin/merchant/user/logout').then(async () => {
      commit('SET_CURRENT_USER', null)
      await saveState('auth.currentUser', null)
      await saveState('auth.currentUserComponents', null)
      commit('SET_CURRENT_USER_ACCESS', {
        assets: [],
        components: [],
      })
      await saveState('auth.currentUserRoutes', [])
      await saveState('auth.currentUserComponents', [])
      await saveState('auth.currentUserPermission', null)

      commit('SET_CURRENT_USER_TOUR', null)
      await saveState('auth.currentUserTours', null)

      commit('SET_CURRENT_USER_ACCOUNT', null)
      await saveState('auth.currentUserAccount', null)

      commit('CLEAR_MERCHANT_CACHED')
      await saveState('merchant.cached', {})

      resetRouter()
      return Promise.resolve()
    })
  },
  validateOrder({ commit }, orderId) {
    return validateUser(
      {
        commit,
      },
      `/merchant/${orderId}/valid`
    )
  },
  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state, dispatch }) {
    if (!state.currentUser) return Promise.resolve(null)

    return validateUser(
      {
        commit,
        dispatch,
      },
      '/admin/merchant/user/login'
    )
  },
}

// ===
// Private helpers
// ===

function validateUser({ commit }, requestPath) {
  return request
    .get(requestPath, {
      errorHandle: false,
    })
    .then(async (response) => {
      const user = response.items

      commit('SET_CURRENT_USER', user)
      await saveState('auth.currentUser', user)

      return user
    })
    .catch(async (error) => {
      if (error && error.code === 401) {
        router.push({
          name: 'logout',
        })
        // commit('SET_CURRENT_USER', null)
        // await saveState('auth.currentUser', null);
      }
      return null
    })
}

function setDefaultAuthHeaders(state) {
  request.defaults.headers.common.Authorization = state.currentUser ? `Bearer ${state.currentUser.token}` : ''
}
